import { getInventariosCabPanel } from "../../services/InventariosCabServices";
import { InventariosCabContext } from "./InventariosCabContext"

export const InventariosCabState = ({ children }) => {
  const getInventariosCabPanelData = async (searchIDSel, searchIDDepo, searchID, dateFrom, dateUntil, numPagina, filas) => {
  let res = await getInventariosCabPanel(searchIDSel, searchIDDepo, searchID, dateFrom, dateUntil, numPagina, filas);
  return res;
};

    return <InventariosCabContext.Provider value={{ 
        getInventariosCabPanelData,
    }} >
        {children}
    </InventariosCabContext.Provider>
}